import { useRouter } from 'next/router';
import { useSession } from 'next-auth/client';
import { useEffect } from 'react';
import { useAuth } from 'src/shared/hooks/use-auth';
export const withRoute = (Component) => {
  const Wrapper = () => {
    const [session, loading]: any = useSession();
    const { accessToken, setAccessToken, setOrgId, setIsPublicFile } = useAuth((state) => ({
      accessToken: state.accessToken,
      setAccessToken: state.setAccessToken,
      setOrgId: state.setOrgId,
      setIsPublicFile: state.setIsPublicFile,
    }));

    const fetchUserDetails = useAuth((s) => s.fetchUserDetails);
    const router = useRouter();
    useEffect(() => {
      if (session?.accessToken) {
        setAccessToken(session.accessToken);
      }
    }, [session]);

    useEffect(() => {
      setOrgId(router?.query?.orgId as string);
    }, [session, router?.query?.orgId]);

    useEffect(() => {
      if (accessToken) {
        fetchUserDetails();
      }
    }, [accessToken]);

    useEffect(() => {
      setIsPublicFile(true);
    }, [session]);

    if (!loading) {
      return <Component />;
    }
    return <div />;
  };
  Wrapper.layout = Component.layout;
  Wrapper.MetaData = Component.MetaData;
  return Wrapper;
};
